// extracted by mini-css-extract-plugin
export var bodySections = "_bs-8";
export var gray = "_bs-7";
export var green = "_bs-4";
export var iconContainer = "_bs-9";
export var iconWidgetContainer = "_bs-1";
export var phoneIcon = "_bs-2";
export var red = "_bs-5";
export var statusDot = "_bs-3";
export var widgetContainer = "_bs-0";
export var yellow = "_bs-6";